import { defaultApiState } from '../api.state';

export const diseaseMutations = {
  GET_DISEASES_LOADING(state) {
    state.apiState.getDiseases = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_DISEASES_SUCCESS(state, payload) {
    state.apiState.getDiseases = {
      ...defaultApiState,
      success: true,
    };
    state.diseases = payload;
  },
  GET_DISEASES_ERROR(state, error) {
    state.apiState.getDiseases = {
      ...defaultApiState,
      error,
    };
  },
  GET_DISEASE_LOADING(state) {
    state.apiState.getDisease = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_DISEASE_SUCCESS(state, payload) {
    state.apiState.getDisease = {
      ...defaultApiState,
      success: true,
    };
    state.disease = payload;
  },
  GET_DISEASE_ERROR(state, error) {
    state.apiState.getDisease = {
      ...defaultApiState,
      error,
    };
  },
  ADD_DISEASE_LOADING(state) {
    state.apiState.addDisease = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_DISEASE_SUCCESS(state, payload) {
    state.apiState.addDisease = {
      ...defaultApiState,
      success: true,
    };
    state.disease = payload;
  },
  ADD_DISEASE_ERROR(state, error) {
    state.apiState.addDisease = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_DISEASE_LOADING(state) {
    state.apiState.updateDisease = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_DISEASE_SUCCESS(state, payload) {
    state.apiState.updateDisease = {
      ...defaultApiState,
      success: true,
    };
    state.disease = payload;
  },
  UPDATE_DISEASE_ERROR(state, error) {
    state.apiState.updateDisease = {
      ...defaultApiState,
      error,
    };
  },
  GET_CATEGORIES_LOADING(state) {
    state.apiState.getCategories = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_CATEGORIES_SUCCESS(state, payload) {
    state.apiState.getCategories = {
      ...defaultApiState,
      success: true,
    };
    state.categories = payload;
  },
  GET_CATEGORIES_ERROR(state, error) {
    state.apiState.getCategories = {
      ...defaultApiState,
      error,
    };
  },
};
